import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import type { SurveyDetailsV2Dto } from "@/api/types";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useSurveyQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    details: ({ surveyId, category }: { surveyId: string; category: SurveyDetailsV2Dto["category"] }) =>
      queryOptions({
        queryKey: QUERY_KEYS.SURVEY_DETAILS(projectId, surveyId),
        queryFn: () =>
          api.getSurveysDetailsV2(surveyId, {
            includeRankingQuestion: category === "feelAtHome",
          }),
        select: commonAPIDataSelector,
      }),
    suggestedFollowUps: (surveyId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.SURVEY_SUGGESTED_FOLLOW_UPS(projectId, surveyId),
        queryFn: () => api.getSurveysSuggestedFollowUpsV1(surveyId),
        select: commonAPIDataSelector,
        staleTime: Infinity,
      }),
  };
};
